import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, Star, User, MessageSquare } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { GlassCard, API } from './GlassCard';
import { formatEthnicity } from '@/utils/ethnicity';

export default function SupportVendors() {
  const { getAuthHeaders } = useAuth();
  const navigate = useNavigate();
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/vendors/search?limit=50`, { headers: getAuthHeaders() });
        if (res.ok) {
          const d = await res.json();
          setVendors(d.vendors || []);
        }
      } catch {} finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <div className="flex justify-center py-12"><div className="w-6 h-6 border-2 border-[#8B5CF6] border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div className="space-y-6" data-testid="support-vendors">
      <div>
        <h2 className="text-2xl font-bold text-white font-syne flex items-center gap-2"><Heart size={22} className="text-pink-400" /> Support Vendors</h2>
        <p className="text-[#9CA3AF] text-sm mt-1">Browse and support fellow Indigenous vendors</p>
      </div>
      {vendors.length === 0 ? (
        <GlassCard className="text-center py-16"><Heart size={48} className="mx-auto text-[#64748B] mb-4" /><p className="text-[#9CA3AF]">No active vendors yet</p></GlassCard>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {vendors.filter((v) => !v.out_of_commission).map((v) => (
            <GlassCard key={v.vendor_id} className="p-4 hover:border-[#8B5CF6]/20 transition-all cursor-pointer" onClick={() => navigate(`/vendor/${v.vendor_id}`)} data-testid={`support-vendor-${v.vendor_id}`}>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-xl overflow-hidden bg-white/5 flex-shrink-0">
                  {(v.profile_image || v.user_picture) ? <img src={v.profile_image || v.user_picture} className="w-full h-full object-cover" alt="" /> : <div className="w-full h-full flex items-center justify-center text-[#64748B]"><User size={20} /></div>}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-white font-bold font-outfit truncate">{v.business_name}</p>
                  <p className="text-[#9CA3AF] text-xs truncate">{v.location || formatEthnicity(v.ethnicity) || ''}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <Star size={12} className="text-amber-500 fill-amber-500" />
                    <span className="text-stone-300 text-xs">{v.rating?.toFixed(1) || 'New'}</span>
                    {v.starting_price && <span className="text-[#64748B] text-xs">From ${v.starting_price}</span>}
                  </div>
                </div>
                <button onClick={(e) => { e.stopPropagation(); navigate(`/messages/${v.user_id}`); }} className="p-2 rounded-lg bg-[#8B5CF6]/10 text-[#A78BFA] hover:bg-[#8B5CF6]/20"><MessageSquare size={16} /></button>
              </div>
            </GlassCard>
          ))}
        </div>
      )}
    </div>
  );
}
